const colors = {
  ltBlue: '#4C566B',
  dkBlue: '#293149',
  dkPurple: '#2C1427',
  ltPurple: '#5e3c5d',
  whiteish: '#D2CCCC',
}

export default colors;